import React, { Component, Fragment } from "react";
import { getLanguageLocal, languageService } from "../../../Language/language.service";
import { themeService } from "../../../theme/service/activeTheme.service";
import { formFeildStyle } from "../../../wigets/forms/style/formFields";
import InspectionFreqRow, { freqObj } from "../../WorkPlanTemplate/JourneyPlanAddEdit/JourneyPlanFrequency/InspectionFreqRow";
import DayPickerInput from "react-day-picker/DayPickerInput";
import moment from "moment";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { ButtonStyle } from "../../../style/basic/commonControls";
import { GITestStyle } from "./style/GITestStyle";
import MomentLocaleUtils from "react-day-picker/moment";
import _ from "lodash";
import CommonModal from "../../Common/CommonModal";
import { reportsPreview } from "./reportsPreview";
import AssetTestContainer, { CheckBoxFieldCustom } from "../../AssetTests/AssetTests";
import AlertInfoArea from "./AlertInfoArea";
import AddMultiAlerts from "./AddAlerts/AddMultiAlerts";
import "./style.css";
import Icon from "react-icons-kit";
import { checkboxUnchecked } from "react-icons-kit/icomoon/checkboxUnchecked";
import { checkboxChecked } from "react-icons-kit/icomoon/checkboxChecked";
import AssetTestGroup from "./AssetTestGroup";
import { versionInfo } from "../../MainPage/VersionInfo";

const defaultAlertInfo = {
  expiryAlertDays: 0,
  emailUserIds: [],
};
const defaultFormVal = {
  name: "",
  inspectionFreq: { ...freqObj },
  instructionFile: [],
  startDate: "",
  test: "",
  inspectionType: "traversed",
  toggleTrOb: false,
  alertInfo: { ...defaultAlertInfo, emailUserIds: [] },
  alerts: [],
  highlyQualified: false,
  autoCertify: false,
  testGroup: null,
  chainRelations: null,
};

export default class AddTestsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formField: { ...defaultFormVal },
      validationMsgs: {
        name: { required: "", custom: "" },
        //   instructionFile: { required: "", custom: "" },
        startDate: { required: "", custom: "" },
        test: { required: "", custom: "" },
      },
      inspectionFreqValidtion: {
        timeFrameNumber: { message: "", required: false, validation: ["v1", "v2", "v3"] },
        recurNumber: { message: "", required: false, validation: ["v1", "v2", "v3"] },
        freq: { message: "", required: false, validation: ["v1", "v2", "v3"] },
        minDays: { message: "", required: false, validation: ["v2"] },
        maxInterval: { message: "", required: false, validation: ["v2"] },
      },
      testsOptions: [],
      instructionOptions: [],
      allValid: true,
      previewOption: false,
      previewCode: "",
      assetsList: null,
      chainRelationOptions: [],
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.frequenciesChangeHandler = this.frequenciesChangeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showPreview = this.showPreview.bind(this);
    this.setModalOpener = this.setModalOpener.bind(this);
    this.setConfigAssetsModalOpener = this.setConfigAssetsModalOpener.bind(this);
    this.setAddAssetTestConfig = this.setAddAssetTestConfig.bind(this);
    this.receiveToggleMethod = this.receiveToggleMethod.bind(this);
    this.setAssetsConfigLIst = this.setAssetsConfigLIst.bind(this);
    this.setLocationOptions = this.setLocationOptions.bind(this);
  }
  changeHandler(e, blur) {
    let formField = { ...this.state.formField };
    formField[e.target.name] = e.target.value;
    let instructionOptions = [...this.state.instructionOptions];
    let chainRelationOptions = [...this.state.chainRelationOptions];
    const { appFormsTests } = this.props;
    if (e.target.name == "test" && appFormsTests) {
      instructionOptions = [];
      chainRelationOptions = [];
      let selectedForm = _.find(appFormsTests, { code: e.target.value });
      if (selectedForm) {
        this.setState({ previewOption: reportsPreview(selectedForm.code) ? true : false, previewCode: selectedForm.code });
        selectedForm.opt2.allowedInstruction && (instructionOptions = [...selectedForm.opt2.allowedInstruction]);
        formField.instructionFile = instructionOptions;
        chainRelationOptions = this.getChainRelationOptions(selectedForm, appFormsTests);
      } else {
        this.setState({ previewOption: false, previewCode: "" });
      }
    }
    if (e.target.name === "chainRelations") formField[e.target.name] = e.target.value ? [e.target.value] : null;

    if (blur) {
      // TODO : validation on blur
    } else {
      // TODO : basic validation
    }
    let assetsListChange = e.target.name === "startDate" ? { assetsList: null } : {};
    this.setState({
      formField: formField,
      instructionOptions: instructionOptions,
      allValid: true,
      ...assetsListChange,
      chainRelationOptions: chainRelationOptions,
    });
  }
  showPreview(code) {
    this.openModelMethod && this.openModelMethod();
  }

  getChainRelationOptions(selectedForm, appFormsTests) {
    let fixedAssetType = this.props.selectedAssetType.assetTypeClassify == "point";
    if (!fixedAssetType) return [];
    let relationOptionsPrep = selectedForm.opt2.chainRelations
      ? selectedForm.opt2.chainRelations
          .map((c) => {
            let found = appFormsTests.find((at) => at.code === c);
            let valid = found && found.opt2.config && found.opt2.config.find((c) => c.assetType === this.props.selectedAssetType.assetType);
            return { desc: found ? found.description : c, code: c, valid: valid };
          })
          .filter((t) => t.valid)
      : null;
    return relationOptionsPrep || [];
  }
  frequenciesChangeHandler(newFreqRowObj, index, remove) {
    let formField = { ...this.state.formField };
    formField.inspectionFreq = newFreqRowObj;

    this.setState({
      formField: formField,
    });
  }

  componentDidMount() {
    this.calculateValues();
  }
  componentDidUpdate(prevProps, prevState) {
    const { formMode } = this.props;
    const { appFormsTests } = this.props;
    if (formMode && formMode !== prevProps.formMode) {
      this.calculateValues();
    } else if (formMode && appFormsTests && appFormsTests !== prevProps.appFormsTests) {
      this.calculateValues();
    } else if (formMode == "Edit" && this.props.selectedTest && prevProps.selectedTest !== this.props.selectedTest) {
      this.calculateValues();
    }
  }
  calculateValues() {
    const { formMode } = this.props;
    const { appFormsTests } = this.props;
    const { selectedTest } = this.props;
    let formField = { ...defaultFormVal };

    let instructionOptions = [];
    let testsOptions = [];
    let chainRelationOptions = [];
    if (formMode == "Edit" && selectedTest && selectedTest.opt2.config) {
      let findAssetType = _.find(selectedTest.opt2.config, (aTypeConfig) => {
        return this.props.selectedAssetType && aTypeConfig.assetType == this.props.selectedAssetType.assetType;
      });
      if (findAssetType) {
        formField = { ...findAssetType, ...{ inspectionFreq: findAssetType.inspectionFreq } };
        formField.startDate = findAssetType.inspectionFreq.startDate;
        formField.test = selectedTest.code;
        formField.alertInfo = findAssetType.alertInfo ? findAssetType.alertInfo : { ...defaultAlertInfo, emailUserIds: [] };
        formField.alerts = findAssetType.alerts ? findAssetType.alerts : [];
        selectedTest.chainRelations && (formField.chainRelations = findAssetType.chainRelations);

        let relationOptionsPrep = this.getChainRelationOptions(selectedTest, appFormsTests);
        relationOptionsPrep && (chainRelationOptions = relationOptionsPrep);
        selectedTest.opt2 && selectedTest.opt2.allowedInstruction && (instructionOptions = [...selectedTest.opt2.allowedInstruction]);
        formField.instructionFile = instructionOptions;
        testsOptions.push({ text: selectedTest.description, val: formField.test });
        // if (findAssetType.assetTypeClassify && this.props.selectedAssetType.assetTypeClassify == "linear") {
        //   formField.inspectionType == "traversed";
        // }
      }
      this.setState({
        previewOption: reportsPreview(selectedTest.code) ? true : false,
        previewCode: selectedTest.code,
        showCurentAssetTests: true,
        assetsList: null,
        chainRelationOptions: chainRelationOptions,
        inspectionFreqValidtion: {
          timeFrameNumber: { message: "", required: false, validation: ["v1", "v2", "v3"] },
          recurNumber: { message: "", required: false, validation: ["v1", "v2", "v3"] },
          freq: { message: "", required: false, validation: ["v1", "v2", "v3"] },
          minDays: { message: "", required: false, validation: ["v2"] },
          maxInterval: { message: "", required: false, validation: ["v2"] },
        },
      });

      //this.setState({ previewOption: true, previewCode: selectedTest.code });
    } else {
      this.setState({ previewOption: false, previewCode: "", showCurentAssetTests: false, assetsList: null });
    }
    appFormsTests &&
      appFormsTests.forEach((form, index) => {
        if (form.opt2 && form.opt2.config) {
          let findAssetType = _.find(form.opt2.config, (aTypeConfig) => {
            return this.props.selectedAssetType.assetType && aTypeConfig.assetType == this.props.selectedAssetType.assetType;
          });
          if (!findAssetType) testsOptions.push({ text: form.description, val: form.code });
        }
        // if (index == 0 && formMode !== "Edit") {
        //   form.opt2.allowedInstruction.forEach((instruc) => {
        //     instructionOptions.push({ text: instruc, val: instruc });
        //   });
        // }
      });
    testsOptions = _.sortBy(testsOptions, ["text"]);
    this.setState({
      formField: formField,
      instructionOptions,
      testsOptions,
      allValid: true,
    });
  }
  handleSubmit() {
    let isValid = this.validateFields();
    if (isValid) {
      let formField = { ...this.state.formField };
      formField.instructionFile = formField.instructionFile;
      formField.inspectionFreq.startDate = formField.startDate;
      formField.assetsList = this.state.assetsList;
      this.props.handleAddEditTest(formField);
    }
  }

  validateFields() {
    let allValid = true;
    let objKeys = Object.keys(this.state.validationMsgs);
    let validationMsgs = _.cloneDeep(this.state.validationMsgs);
    objKeys.forEach((fieldName) => {
      let isFieldValid = true;
      !this.state.formField[fieldName] && (isFieldValid = false);
      if (isFieldValid) {
        validationMsgs[fieldName].required = false;
        validationMsgs[fieldName].custom = "";
      } else {
        allValid = false;
        validationMsgs[fieldName].required = true;
      }
    });
    let objKeyInspectionFreq = Object.keys(this.state.inspectionFreqValidtion);
    let inspectionFreqValidtion = _.cloneDeep(this.state.inspectionFreqValidtion);
    objKeyInspectionFreq.forEach((fieldName) => {
      let fieldValue = this.state.formField.inspectionFreq[fieldName];
      let fieldObj = this.state.inspectionFreqValidtion[fieldName];
      let valid = validateInputField(fieldObj, fieldValue);
      if (valid.required) {
        allValid = false;
        inspectionFreqValidtion[fieldName] = valid;
      } else {
        inspectionFreqValidtion[fieldName] = valid;
      }
    });
    this.setState({
      validationMsgs: validationMsgs,
      inspectionFreqValidtion: inspectionFreqValidtion,
      allValid: false,
    });
    return allValid;
  }
  setModalOpener(method) {
    this.openModelMethod = method;
  }
  setConfigAssetsModalOpener(method) {
    this.openAssetConfigModel = method;
    //console.log("::" + this.state.formField.name);
  }
  setAddAssetTestConfig(method) {
    this.openAddAssetConfigModel = method;
  }
  receiveToggleMethod(state, field) {
    let stateObj = {};
    stateObj[field] = state;
    if (state === false) {
      this.setState(stateObj);
    }
  }
  setAssetsConfigLIst(assetsList) {
    this.setState({
      assetsList: assetsList,
    });
  }
  setLocationOptions(locations) {
    this.setState({ locations: locations });
  }
  render() {
    return (
      <div className="card" style={{ margin: " 0 10px 0 0" }}>
        <AddAssetTestHeader
          showCurentAssetTests={true}
          openAssetConfigModel={this.props.formMode == "Add" ? this.openAddAssetConfigModel : this.openAssetConfigModel}
          showConfigSetState={
            this.props.formMode === "Add"
              ? (state) => this.setState({ showCreateAssetTestConfig: state })
              : (state) => this.setState({ showConfigAssetsModel: state })
          }
          disabled={this.props.formMode === "Add" && !this.state.formField.startDate}
        />

        <div className="card-body">
          <LabelWithFieldWrapper label={languageService("Name") + " *"}>
            <InputField
              inputFieldProps={{ name: "name", type: "text" }}
              changeHandler={this.changeHandler}
              value={this.state.formField.name}
              validation={this.state.validationMsgs.name}
            />
          </LabelWithFieldWrapper>
          <LabelWithFieldWrapper label={languageService("Test") + " *"}>
            <SelectField
              inputFieldProps={{ name: "test", disabled: this.props.formMode == "Add" ? false : true, id: "test" }}
              addEmptyOption={this.props.formMode == "Add" ? true : false}
              options={this.state.testsOptions}
              changeHandler={this.changeHandler}
              value={this.state.formField.test}
              validation={this.state.validationMsgs.test}
              previewOption={this.state.previewOption}
              previewCode={this.state.previewCode}
              showPreview={this.showPreview}
            />
          </LabelWithFieldWrapper>
          <LabelWithFieldWrapper label={languageService("Instruction files")}>
            <div className="instruction-files-list">
              {this.state.instructionOptions.length > 0 ? (
                this.state.instructionOptions.map((fileName) => <div>{fileName}</div>)
              ) : (
                <div>{languageService("No files available")}</div>
              )}
            </div>
            {/* <SelectField
              inputFieldProps={{ name: "instructionFile" }}
              options={this.state.instructionOptions}
              changeHandler={this.changeHandler}
              value={this.state.formField.instructionFile}
            /> */}
          </LabelWithFieldWrapper>
          {this.props.selectedAssetType && this.props.selectedAssetType.assetTypeClassify == "linear" && (
            <LabelWithFieldWrapper label={languageService("Inspection Type")}>
              <div style={{ display: "flex" }}>
                <div>
                  <SelectField
                    inputFieldProps={{ name: "inspectionType" }}
                    options={[
                      { val: "traversed", text: "Traverse" },
                      { val: "observed", text: "Observe" },
                      { val: "both", text: "Traverse/Observe" },
                    ]}
                    changeHandler={this.changeHandler}
                    value={this.state.formField.inspectionType}
                  />
                </div>
                {false && (
                  <div
                    style={{ marginLeft: "5px" }}
                    className="asset-check-box"
                    onClick={(e) => this.changeHandler({ target: { name: "toggleTrOb", value: !this.state.formField.toggleTrOb } })}
                  >
                    <Icon icon={this.state.formField.toggleTrOb ? checkboxChecked : checkboxUnchecked} size={20} />
                    <span style={{ marginLeft: "2px" }}> toggle</span>
                  </div>
                )}
              </div>
            </LabelWithFieldWrapper>
          )}
          <LabelWithFieldWrapper label={languageService("Start Date") + " *"}>
            <DateField
              inputFieldProps={{ name: "startDate" }}
              changeHandler={this.changeHandler}
              value={this.state.formField.startDate}
              validation={this.state.validationMsgs.startDate}
            />
          </LabelWithFieldWrapper>
          {this.state.chainRelationOptions && this.state.chainRelationOptions.length > 0 && (
            <LabelWithFieldWrapper label={languageService("Chain Completion")}>
              <div style={{ display: "flex" }}>
                <div>
                  <SelectField
                    addEmptyOption={true}
                    inputFieldProps={{ name: "chainRelations" }}
                    options={
                      this.state.chainRelationOptions.length > 0
                        ? this.state.chainRelationOptions.map((obj) => ({ val: obj.code, text: obj.desc }))
                        : [{ val: "", text: "" }]
                    }
                    changeHandler={this.changeHandler}
                    value={
                      this.state.formField.chainRelations && this.state.formField.chainRelations[0]
                        ? this.state.formField.chainRelations[0]
                        : ""
                    }
                  />
                </div>
              </div>
            </LabelWithFieldWrapper>
          )}
          {versionInfo.isReVAMP() && (
            <CheckBoxFieldCustom
              value={this.state.formField.highlyQualified}
              name="highlyQualified"
              onChangeHandler={this.changeHandler}
              label={"Highly Qualified Inspector Test"}
            />
          )}

          {versionInfo.isReVAMP() && (
            <CheckBoxFieldCustom
              value={this.state.formField.autoCertify}
              name="autoCertify"
              onChangeHandler={this.changeHandler}
              label={"Auto Certify Test"}
            />
          )}
          {this.props.assetTestsGroup && this.props.assetTestsGroup.length > 0 && (
            <React.Fragment>
              <span className="spacer"></span>
              <AssetTestGroup
                testGroups={this.props.assetTestsGroup}
                testGroup={this.state.formField.testGroup}
                changeHandler={this.changeHandler}
              />
            </React.Fragment>
          )}
          <span className="spacer"></span>
          <InspectionFreqRow
            frequenciesChangeHandler={this.frequenciesChangeHandler}
            rowIndex={0}
            freqObject={this.state.formField.inspectionFreq}
            inspectionFreqValidtion={this.state.inspectionFreqValidtion}
          />
          <div style={{ border: "1px solid rgb(177, 177, 177)", padding: "10px 10px 0px  10px", width: "auto", marginBottom: "10px" }}>
            <AlertInfoArea
              alertLabel={"Expiry Status Alert Span"}
              postLabel={languageService("days")}
              noUserList={true}
              noOverdueAlertCheckbox={true}
              changeHandler={this.changeHandler}
              alertInfo={this.state.formField.alertInfo}
            />
          </div>
          <AddMultiAlerts
            alertUserList={this.props.alertUserList}
            changeHandler={this.changeHandler}
            alerts={this.state.formField.alerts}
            userList={this.props.userList}
          />
        </div>
        <div className="card-footer" style={{ ...themeService(GITestStyle.cardBodyHeader), textAlign: "right" }}>
          {!this.state.allValid && (
            <span style={{ fontSize: "12px", color: "red" }}> {languageService("Validation failed , please fill required fields")} </span>
          )}
          <MyButton
            onClick={(e) => {
              this.handleSubmit();
            }}
            type="submit"
            style={themeService(ButtonStyle.commonButton)}
          >
            {this.props.formMode == "Add" ? languageService("Add") : languageService("Update")}
          </MyButton>
        </div>
        <CommonModal className="report-view" setModalOpener={this.setModalOpener} modalStyle={{ maxWidth: "80vw" }}>
          {reportsPreview(this.state.previewCode)}
        </CommonModal>
        <CommonModal
          setModalOpener={this.setConfigAssetsModalOpener}
          className="report-view"
          receiveToggleMethod={(state) => this.receiveToggleMethod(state, "showConfigAssetsModel")}
          modalStyle={{ maxWidth: "70vw", maxHeight: "70vh" }}
          headerText={languageService("Assets Tests Configuration")}
          footerCancelText={"Close"}
        >
          {this.state.showConfigAssetsModel && (
            <AssetTestContainer assetType={this.props.selectedAssetType} testCode={this.props.selectedTest} createMode={false} />
          )}
        </CommonModal>
        <CommonModal
          setModalOpener={this.setAddAssetTestConfig}
          className="report-view"
          receiveToggleMethod={(state) => this.receiveToggleMethod(state, "showCreateAssetTestConfig")}
          modalStyle={{ maxWidth: "70vw", maxHeight: "70vh" }}
          headerText={languageService("Assets Tests Configuration")}
          footerCancelText={"Close"}
          handleCancelClick={() => {
            this.receiveToggleMethod(false, "showCreateAssetTestConfig");
          }}
        >
          {this.state.showCreateAssetTestConfig && (
            <Fragment>
              <AssetTestContainer
                assetType={this.props.selectedAssetType}
                testCode={this.state.formField.test}
                startDate={this.state.formField.startDate}
                assetsList={this.state.assetsList}
                setAssetsConfigLIst={this.setAssetsConfigLIst}
                locations={this.state.locations}
                setLocationOptions={this.setLocationOptions}
                testName={this.state.formField.name}
                createMode={true}
              />
            </Fragment>
          )}
        </CommonModal>
      </div>
    );
  }
}

let validationsObj = {
  // check if field is empty
  v1: {
    cond: (value) => !value,
    message: "Field value required",
    required: true,
  },
  // check if number is real if provided
  v2: { cond: (value) => parseFloat(value) % 1 !== 0 && value, message: "Please enter a valid value.", required: true },
  // Value must be greater than 0
  v3: {
    cond: (value) => parseFloat(value) <= 0,
    message: "Value should be greater than 0",
    required: true,
  },
};

function validateInputField(inputFieldState, value) {
  let validations = inputFieldState.validation;
  for (let i = 0; i <= validations.length - 1; i++) {
    let validate = validationsObj[validations[i]];
    let condition = validate.cond(value);
    if (condition) {
      inputFieldState.message = validate.message;
      inputFieldState.required = validate.required;
      break;
    } else {
      inputFieldState.message = "";
      inputFieldState.required = false;
    }
  }
  return inputFieldState;
}
const AddAssetTestHeader = (props) => {
  return (
    <div className="card-header " style={themeService(GITestStyle.cardBodyHeader)}>
      {languageService("Add") + " " + "Tests"}
      {props.showCurentAssetTests && (
        <span style={{ float: "right" }}>
          <MyButton
            onClick={(e) => {
              props.openAssetConfigModel && props.openAssetConfigModel();
              props.showConfigSetState && props.showConfigSetState(true);
            }}
            disabled={props.disabled}
          >
            {languageService("Configure Assets")}
          </MyButton>
        </span>
      )}
    </div>
  );
};

export const InputField = (props) => {
  return (
    <div style={{ ...props.style, ...themeService(formFeildStyle.feildStyle), margin: "0px 0px 15px 0px", display: "inline-block" }}>
      {props.inputFieldProps.label && (
        <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "0px 5px 5px" }}>
          {props.inputFieldProps.label + ":"}
        </label>
      )}
      <input
        style={{ ...themeService(formFeildStyle.inputStyle), minWidth: "250px" }}
        disabled={props.inputFieldProps.disabled}
        onChange={(e) => props.changeHandler(e, false)}
        onBlur={(e) => props.changeHandler(e, true)}
        value={props.value}
        {...props.inputFieldProps}
      />
    </div>
  );
};

export const SelectField = (props) => {
  const style = props.style ? props.style : {};
  return (
    <div style={{ ...themeService(formFeildStyle.feildStyle), ...style }}>
      {props.label && (
        <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "0px 5px 5px" }}>
          {languageService(props.label) + ":"}
        </label>
      )}
      <select
        style={{ ...themeService(formFeildStyle.inputStyle), minWidth: "250px", borderWidth: "2px" }}
        onChange={(e) => props.changeHandler(e, false, "select")}
        onBlur={(e) => props.changeHandler(e, true, "select")}
        {...props.inputFieldProps}
        value={props.value}
      >
        {props.addEmptyOption && <option> </option>}
        {props.options &&
          props.options.map((item, index) => (
            <option key={index} value={item.val}>
              {languageService(item.text)}
            </option>
          ))}
      </select>
      {props.previewOption && (
        <span style={{ color: "var(--first)", cursor: "pointer", marginLeft: "10px" }} onClick={() => props.showPreview(props.previewCode)}>
          {languageService("Preview")}...
        </span>
      )}
    </div>
  );
};

export const LabelWithFieldWrapper = (props) => {
  const lblStyle = props.lblStyle ? props.lblStyle : {};
  const fieldStyle = props.fieldStyle ? props.fieldStyle : {};
  return (
    <div>
      <div style={{ margin: "0 10px 5px 0", fontSize: "14px", fontWeight: 600, display: "inline-block", width: "200px", ...lblStyle }}>
        {languageService(props.label)}
      </div>
      {props.directChildren ? (
        props.children
      ) : (
        <div style={{ display: "inline-block", minWidth: "250px", ...fieldStyle }}>{props.children}</div>
      )}

      {props.postLabel && (
        <div style={{ margin: "0 10px 5px 10px", fontSize: "14px", fontWeight: 400, display: "inline-block" }}>{props.postLabel}</div>
      )}
    </div>
  );
};

export const DateField = (props) => {
  const handleInputChange = (e) => {
    const { value } = e.target;
    const formattedDate = moment(value).format("Y-M-D");
    props.changeHandler({ target: { name: props.inputFieldProps.name, value: formattedDate } });
  };
  return (
    <div>
      <DayPickerInput
        inputProps={{ readOnly: true, disabled: props.disabled || false }}
        {...props.inputFieldProps}
        value={props.value ? moment(props.value).format("Y-M-D") : ""}
        dayPickerProps={{
          month: props.value ? new Date(props.value) : new Date(),
          localeUtils: MomentLocaleUtils,
          locale: getLanguageLocal(),
        }}
        onDayChange={(day) => {
          props.changeHandler({ target: { name: props.inputFieldProps.name, value: day } });
        }}
        className="myTestClass"
        style={props.style ? props.style : { ...themeService(formFeildStyle.inputStyle) }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SetupPage/GITestAssetTypes/AddTestsForm.jsx